exports.server = "https://api.docity.co"

